import React, { useContext, useEffect, useState, useRef } from "react";
import { Context } from "../context/Context";
import { hadesListData } from "../Database/Database";
import { useLocation, useHistory, useParams, Link } from "react-router-dom";
import { SendGuiDataEvents } from "../lib/CommonScript";
import Loader from "./Loader";

export default function HadesList(props) {
  const location = useLocation();
  const history = useHistory();
  const { audios } = props.location.state;

  const { lang, theme } = useContext(Context);
  const { id } = useParams();
  // var listData = hadesListData[lang]

  // console.log("list dadta",listData)

  console.log("helooooo");
  console.log("state data --> ", props.location.state);
  console.log("audios --> ", audios);

  const audioRef = useRef(null);

  // const songs = [
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_001.mp3", name: "Sahihbukhari-001", id: "id_1" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_002.mp3", name: "Sahihbukhari-002", id: "id_2" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_004.mp3", name: "Sahihbukhari-004", id: "id_3" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_006.mp3", name: "Sahihbukhari-006", id: "id_4" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_008.mp3", name: "Sahihbukhari-008", id: "id_5" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_015.mp3", name: "Sahihbukhari-015", id: "id_6" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_037.mp3", name: "Sahihbukhari-037", id: "id_7" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_153.mp3", name: "Sahihbukhari-153", id: "id_8" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_291.mp3", name: "Sahihbukhari-291", id: "id_9" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_703.mp3", name: "Sahihbukhari-703", id: "id_10" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_908.mp3", name: "Sahihbukhari-908", id: "id_11" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_919.mp3", name: "Sahihbukhari-919", id: "id_12" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_953.mp3", name: "Sahihbukhari-953", id: "id_13" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_986.mp3", name: "Sahihbukhari-986", id: "id_14" },
  //     { fileSource: "https://multimedia.ibadatapp.com/hadith/audios/sahihbukhari_989.mp3", name: "Sahihbukhari-989", id: "id_15" },
  // ];

  const songs = audios;

  const [isPlaying, setIsPlaying] = useState(false);
  var currSongInd = localStorage.getItem("currSongInd")
    ? parseInt(localStorage.getItem("currSongInd"))
    : 0;
  console.log("currSongInd --------->", currSongInd);
  const [currentSong, setCurrentSong] = useState(songs[currSongInd]);
  const [songIndex, setSongIndex] = useState(currSongInd);
  const [isLoading, setIsLoading] = useState(false);

  const playIcon = require("../assets/red/play_button_audio.png");
  const pauseIcon = require("../assets/red/pause_button_audio.png");
  const dancingBars = require("../assets/dancingBars.gif");
  const musicIcon = require("../assets/red/audio_icon.png");

  // useEffect(() => {
  //   //send gui events
  //   let guiDataEvent = {};
  //   guiDataEvent["page"] = "HadithList";
  //   guiDataEvent["event"] = "open";
  //   SendGuiDataEvents(guiDataEvent);
  // }, []);



  const endSongHandle = () => {
    console.log("inside next auto play");
    let currentIndex = songs.findIndex(
      (song) => song.name === currentSong.name
    );
    setCurrentSong(songs[currentIndex + 1]);
    console.log("current song index ----->", currentIndex + 1);
    setSongIndex(currentIndex + 1);
    if (isPlaying && audioRef.current) {
      setTimeout(() => audioRef.current.play(), 100);
    }
  };

  // useEffect(() => {
  //     if (isPlaying) {
  //         audioRef.current.play()
  //     } else if (audioRef.current) {
  //         audioRef.current.pause()
  //     }
  //     console.log("is playing :", isPlaying)
  // }, [isPlaying])

  const handleClick = (key) => {
    localStorage.setItem("currSongInd", key);
    setCurrentSong(songs[key]);
    setSongIndex(key);
    if (isPlaying && currentSong.id === songs[key].id) {
      setIsPlaying(!isPlaying);
      setTimeout(() => audioRef.current.pause(), 100);
    } else {
      setIsPlaying(true);
      setTimeout(() => audioRef.current.play(), 100);
    }
  };

  function playPauseIconHandle() {
    if (!localStorage.getItem("currSongInd")) {
      localStorage.setItem("currSongInd", 0);
    }
    if (JSON.stringify(currentSong) !== "{}") {
      if (isPlaying) {
        console.log("inside play");
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        console.log("inside play - showing loader");
        setIsLoading(true);
        audioRef.current.play()
          .then(() => {
            console.log("Audio play promise resolved");
            setIsPlaying(true);
            // Don't hide loader here, let audio events handle it
          })
          .catch((err) => {
            console.error("Audio play failed:", err);
            setIsLoading(false);
          });
      }
    }
    console.log(" handle play pause btn clicked");
  }

  const handleAudioLoadStart = () => {
    console.log("Audio loading started");
    setIsLoading(true);
  };
  
  
  const handleAudioPlaying = () => {
    console.log("Audio is now playing - hiding loader");
    // Add a small delay to ensure loader is visible
    setTimeout(() => {
      setIsLoading(false);
    }, 800); // 800ms delay to ensure visibility
  };

  const handleAudioError = () => {
    console.log("Audio error - hiding loader");
    setIsLoading(false);
  };

  // Fallback timeout to hide loader if audio events don't fire
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isLoading) {
        console.log("Timeout reached - hiding loader as fallback");
        setIsLoading(false);
      }
    }, 10000); // 10 second timeout

    return () => clearTimeout(timeout);
  }, [isLoading])

  console.log("audios ---> ", audios);

  return (
    <div
      className={`min-h-screen w-full bg-cover bg-center bg-no-repeat ${
        theme === "red" ? "bg-red_bg_pic" : "bg-bgGreenIslam"
      } pt-16 max-width`}
    >
      {isLoading && <Loader />}
      <div
        className="w-16 h-16 left-0 right-0 cursor-pointer mx-auto"
        onClick={playPauseIconHandle}
      >
        <img src={isPlaying ? pauseIcon : playIcon} />
      </div>
      {/* <div className="text-black mb-8 py-2"> <div onClick={() => {
                playPauseIconHandle()
            }}><img style={{}} src= {isPlaying ? pauseIcon : playIcon} /> </div></div> */}
      <div className="px-4 h-75v bg-gray-100 mt-4 mx-2 py-2  overflow-y-auto  rounded-lg">
        {/* {listData && listData.head && <div className="font-bold w-full py-2 text-redThemePrimaryRedColor">{listData.head}</div>} */}
        {audios.map((element, ind) => {
          return (
            <div
              onClick={() => {
                handleClick(ind);
              }}
              key={ind}
              className={`border-b py-4 cursor-pointer overflow-y-auto  ${
                localStorage.getItem("currSongInd") && songIndex === ind
                  ? "bg-smoke-light rounded -mx-1 text-white"
                  : null
              }`}
            >
              <div className={`text-center relative`}>
                <div className="absolute pl-1">
                  <img
                    src={
                      isPlaying && songIndex === ind ? dancingBars : musicIcon
                    }
                    style={{ width: "1.8rem" }}
                  />
                </div>
                <p className="pl-4" dir="rtl">
                  {element.title}
                </p>
              </div>
              <audio
                ref={audioRef}
                src={currentSong?.fileSource}
                onEnded={endSongHandle}
                onLoadStart={handleAudioLoadStart}
  onPlaying={handleAudioPlaying}
  onError={handleAudioError}
  preload="auto"
              ></audio>
            </div>
          );
        })}
      </div>
      {/* <div onClick={() => history.goBack()} className="mx-auto border w-1/2 my-4 py-2 py-auto bg-redThemePrimaryRedColor rounded-xl text-white">Previous Month</div> */}
    </div>
  );
}
